import "core-js/modules/es.array.reverse.js";
var _class, _YDYRCatalogFunction;
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed, makeObservable, override } from "mobx";
import filterOutUndefined from "../../../Core/filterOutUndefined";
import isDefined from "../../../Core/isDefined";
import CatalogFunctionMixin from "../../../ModelMixins/CatalogFunctionMixin";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import TableMixin from "../../../ModelMixins/TableMixin";
import TableColumnType from "../../../Table/TableColumnType";
import YDYRCatalogFunctionTraits from "../../../Traits/TraitsClasses/YDYRCatalogFunctionTraits";
import CreateModel from "../../Definition/CreateModel";
import BooleanParameter from "../../FunctionParameters/BooleanParameter";
import EnumerationParameter from "../../FunctionParameters/EnumerationParameter";
import InfoParameter from "../../FunctionParameters/InfoParameter";
import StringParameter from "../../FunctionParameters/StringParameter";
import YDYRCatalogFunctionJob from "./YDYRCatalogFunctionJob";
export const DATASETS = [{
  title: "ABS - 2011 Statistical Areas Level 1",
  filename: "SA1_2011_AUST",
  dataCol: "SA1_MAIN11",
  geographyName: "SA1_2011",
  sideData: "BCP_2011"
}, {
  title: "ABS - 2011 Statistical Areas Level 2",
  filename: "SA2_2011_AUST",
  dataCol: "SA2_MAIN11",
  geographyName: "SA2_2011",
  sideData: "BCP_2011"
}, {
  title: "ABS - 2011 Statistical Areas Level 3",
  filename: "SA3_2011_AUST",
  dataCol: "SA3_CODE11",
  geographyName: "SA3_2011",
  sideData: "BCP_2011"
}, {
  title: "ABS - 2011 Statistical Areas Level 4",
  filename: "SA4_2011_AUST",
  dataCol: "SA4_CODE11",
  geographyName: "SA4_2011",
  sideData: "BCP_2011"
}, {
  title: "ABS - 2011 Local Government Areas",
  filename: "LGA_2011_AUST",
  dataCol: "LGA_CODE11",
  geographyName: "LGA_2011",
  sideData: "BCP_2011"
}, {
  title: "ABS - 2011 Commonwealth Electoral Divisions",
  filename: "CED_2011_AUST",
  dataCol: "CED_CODE11",
  geographyName: "CED_2011",
  sideData: "BCP_2011"
}, {
  title: "ABS - 2011 State Electoral Divisions",
  filename: "SED_2011_AUST",
  dataCol: "SED_CODE11",
  geographyName: "SED_2011",
  sideData: "BCP_2011"
}, {
  title: "ABS - 2011 Remoteness Areas 2011",
  filename: "RA_2011_AUST",
  dataCol: "RA_CODE11",
  geographyName: "RA_2011",
  sideData: "BCP_2011"
}, {
  title: "ABS - 2011 State Suburbs",
  filename: "SSC_2011_AUST",
  dataCol: "SSC_CODE11",
  geographyName: "SSC_2011",
  sideData: "BCP_2011"
}, {
  title: "ABS - 2011 Postal Areas",
  filename: "POA_2011_AUST",
  dataCol: "POA_CODE",
  geographyName: "POA_2011",
  sideData: "BCP_2011"
}, {
  title: "ABS - 2016 Statistical Areas Level 1",
  filename: "SA1_2016_AUST",
  dataCol: "SA1_MAIN16",
  geographyName: "SA1_2016",
  sideData: "BCP_2016"
}, {
  title: "ABS - 2016 Statistical Areas Level 2",
  filename: "SA2_2016_AUST",
  dataCol: "SA2_MAIN16",
  geographyName: "SA2_2016",
  sideData: "BCP_2016"
}, {
  title: "ABS - 2016 Statistical Areas Level 3",
  filename: "SA3_2016_AUST",
  dataCol: "SA3_CODE16",
  geographyName: "SA3_2016",
  sideData: "BCP_2016"
}, {
  title: "ABS - 2016 Statistical Areas Level 4",
  filename: "SA4_2016_AUST",
  dataCol: "SA4_CODE16",
  geographyName: "SA4_2016",
  sideData: "BCP_2016"
}, {
  title: "ABS - 2016 Local Government Areas",
  filename: "LGA_2016_AUST",
  dataCol: "LGA_CODE16",
  geographyName: "LGA_2016",
  sideData: "BCP_2016"
}, {
  title: "ABS - 2016 Commonwealth Electoral Divisions",
  filename: "CED_2016_AUST",
  dataCol: "CED_CODE16",
  geographyName: "CED_2016",
  sideData: "BCP_2016"
}, {
  title: "ABS - 2016 State Electoral Divisions",
  filename: "SED_2016_AUST",
  dataCol: "SED_CODE16",
  geographyName: "SED_2016",
  sideData: "BCP_2016"
}, {
  title: "ABS - Remoteness Areas 2016",
  filename: "RA_2016_AUST",
  dataCol: "RA_CODE16",
  geographyName: "RA_2016",
  sideData: "BCP_2016"
}, {
  title: "ABS - 2016 State Suburbs",
  filename: "SSC_2016_AUST",
  dataCol: "SSC_CODE16",
  geographyName: "SSC_2016",
  sideData: "BCP_2016"
}, {
  title: "ABS - 2016 Postal Areas",
  filename: "POA_2016_AUST",
  dataCol: "POA_CODE16",
  geographyName: "POA_2016",
  sideData: "BCP_2016"
}];
export const SIDE_DATA = [{
  title: "Basic Community profile 2011",
  id: "BCP_2011"
}, {
  title: "Basic Community profile 2016",
  id: "BCP_2016"
}];
export const ALGORITHMS = [["Negative Binomial", true], ["Population Weighted", false]
// ["Poisson Linear", false],
// ["Ridge Regressor", false]
];
let YDYRCatalogFunction = (_class = (_YDYRCatalogFunction = class YDYRCatalogFunction extends CatalogFunctionMixin(CreateModel(YDYRCatalogFunctionTraits)) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get type() {
    return YDYRCatalogFunction.type;
  }
  get typeName() {
    return "YourDataYourRegions";
  }
  async createJob(id) {
    return new YDYRCatalogFunctionJob(id, this.terria);
  }
  async forceLoadMetadata() {
    return super.forceLoadMetadata();
    // TODO: load capabilities from https://ydyr.info/api/v1/capability?format=json
    // https://github.com/TerriaJS/terriajs/issues/4943
  }
  get description() {
    var _super$description;
    return (_super$description = super.description) !== null && _super$description !== void 0 ? _super$description : "Your Data Your Regions (YDYR) is an API for the conversion of data between different Australian geographic boundaries. See <a href=\"https://ydyr.info\">ydyr.info</a> for more information";
  }
  get selectedTableCatalogMember() {
    var _this$inputLayers;
    if (!isDefined((_this$inputLayers = this.inputLayers) === null || _this$inputLayers === void 0 ? void 0 : _this$inputLayers.value)) {
      return;
    }
    const layer = this.terria.workbench.items.filter(TableMixin.isMixedInto).filter(item => item.uniqueId === this.inputLayers.value)[0];
    return layer;
  }
  get apiUrl() {
    return new StringParameter(this, {
      id: "apiUrl",
      name: "YDYR API Endpoint",
      isRequired: true
    });
  }
  get inputLayers() {
    const possibleValues = this.terria.workbench.items.filter(item => TableMixin.isMixedInto(item) && item.activeTableStyle.isRegions()).filter(item => item.uniqueId).map(item => {
      return {
        id: item.uniqueId,
        name: CatalogMemberMixin.isMixedInto(item) ? item.name : undefined
      };
    });
    return new EnumerationParameter(this, {
      id: "Input Layer",
      description: "Select a layer which contains the tabular data you want to convert to another geography, It should contain at least two columns:\n- A geography column containing unique codes (eg postcodes)\n- A data column containing the values you want to convert (eg number of households by postcode)",
      options: possibleValues,
      isRequired: true
    });
  }
  get inputLayersInfo() {
    let value = "";
    if (isDefined(this.inputLayers.value) && !this.inputLayers.isValid) {
      value = "The selected layer \"".concat(this.inputLayers.value, " does not exist in the map\". ");
    }
    if (this.inputLayers.options.length === 0) {
      value = "No supported input layers available, please add a region-mapped data layer to the map.";
    }
    if (value !== "") {
      return new InfoParameter(this, {
        id: "inputLayersError",
        name: "Input Layer Error",
        errorMessage: true,
        value
      });
    }
  }
  get regionColumn() {
    var _this$selectedTableCa;
    if (!this.inputLayers.isValid) {
      return;
    }
    const possibleValues = ((_this$selectedTableCa = this.selectedTableCatalogMember) === null || _this$selectedTableCa === void 0 ? void 0 : _this$selectedTableCa.tableColumns
    // Filter region columns which use supported regions
    .filter(col => col.type === TableColumnType.region && isDefined(DATASETS.find(d => {
      var _col$regionType;
      return d.dataCol === ((_col$regionType = col.regionType) === null || _col$regionType === void 0 ? void 0 : _col$regionType.regionProp);
    }))).map(col => {
      return {
        id: col.name
      };
    })) || [];
    return new EnumerationParameter(this, {
      id: "Region Column",
      description: "The data source field which contains unique codes for the input geography.",
      options: possibleValues,
      isRequired: true
    });
  }
  get regionColumnInfo() {
    var _this$regionColumn;
    if (this.inputLayers.isValid && ((_this$regionColumn = this.regionColumn) === null || _this$regionColumn === void 0 ? void 0 : _this$regionColumn.options.length) === 0) {
      return new InfoParameter(this, {
        id: "regionColumnError",
        name: "Region Column Error",
        errorMessage: true,
        value: "No region columns available, the selected layer \"".concat(this.inputLayers.value, "\" doesn't have any supported region columns.\nThe region mapping can be set in the Workbench.\n\n**Supported regions:**\n").concat(DATASETS.map(d => "\n- ".concat(d.title)))
      });
    }
  }
  get dataColumn() {
    var _this$selectedTableCa2;
    if (!this.inputLayers.isValid) {
      return;
    }
    const possibleValues = ((_this$selectedTableCa2 = this.selectedTableCatalogMember) === null || _this$selectedTableCa2 === void 0 ? void 0 : _this$selectedTableCa2.tableColumns.filter(col => col.type === TableColumnType.scalar).map(col => {
      return {
        id: col.name
      };
    })) || [];
    return new EnumerationParameter(this, {
      id: "Data Column",
      description: "The data source field which contains the values for the data to be converted.",
      options: possibleValues,
      isRequired: true
    });
  }
  get dataColumnInfo() {
    var _this$dataColumn;
    if (this.inputLayers.isValid && ((_this$dataColumn = this.dataColumn) === null || _this$dataColumn === void 0 ? void 0 : _this$dataColumn.options.length) === 0) {
      return new InfoParameter(this, {
        id: "dataColumnError",
        name: "Data Column Error",
        errorMessage: true,
        value: "No data columns available, the selected layer \"".concat(this.inputLayers.value, "\" doesn't have any numerical columns.")
      });
    }
  }
  get availableRegions() {
    var _this$regionColumn2;
    if (!((_this$regionColumn2 = this.regionColumn) !== null && _this$regionColumn2 !== void 0 && _this$regionColumn2.isValid)) {
      return;
    }
    return new EnumerationParameter(this, {
      id: "Output Geography",
      description: "The output geography to be converted to.",
      options: DATASETS.map(d => {
        return {
          id: d.title
        };
      }),
      isRequired: true
    });
  }
  get algorithmParametersInfo() {
    if (this.algorithmParameters.length > 0) {
      return new InfoParameter(this, {
        id: "algorithmsInfo",
        name: "Select Algorithms",
        value: "Predictive models used to convert data between the input and output geographies:"
      });
    }
  }
  get algorithmParameters() {
    var _this$regionColumn3, _this$dataColumn2, _this$availableRegion;
    if (!((_this$regionColumn3 = this.regionColumn) !== null && _this$regionColumn3 !== void 0 && _this$regionColumn3.isValid) || !((_this$dataColumn2 = this.dataColumn) !== null && _this$dataColumn2 !== void 0 && _this$dataColumn2.isValid) || !((_this$availableRegion = this.availableRegions) !== null && _this$availableRegion !== void 0 && _this$availableRegion.isValid)) {
      return [];
    }
    return ALGORITHMS.map(alg => new BooleanParameter(this, {
      id: alg[0]
    }));
  }
  get submitWarning() {
    var _this$regionColumn4, _this$dataColumn3, _this$availableRegion2;
    if (this.inputLayers.isValid && (_this$regionColumn4 = this.regionColumn) !== null && _this$regionColumn4 !== void 0 && _this$regionColumn4.isValid && (_this$dataColumn3 = this.dataColumn) !== null && _this$dataColumn3 !== void 0 && _this$dataColumn3.isValid && (_this$availableRegion2 = this.availableRegions) !== null && _this$availableRegion2 !== void 0 && _this$availableRegion2.isValid) {
      return new InfoParameter(this, {
        id: "dataWarning",
        name: "Warning",
        errorMessage: false,
        value: "By submitting this form your tabular data will be sent to ".concat(this.apiUrl.value, " for processing.")
      });
    }
  }

  // Disabled due to lack of get capabilities from YDYR server
  // @computed get sidedataParameters(): EnumerationParameter {
  //   const possibleValues = SIDE_DATA.map(data => data.title);
  //   let value = possibleValues[0]
  //   if (isDefined(this.availableRegions.value)) {

  //   }
  //   return new EnumerationParameter({
  //     id: "Side data",
  //     possibleValues,
  //     value: possibleValues[0]
  //   });
  // }

  /**
   *  Maps the input to function parameters.
   */
  get functionParameters() {
    return filterOutUndefined([this.apiUrl, this.inputLayers, this.inputLayersInfo, this.regionColumnInfo || this.regionColumn, this.dataColumnInfo || this.dataColumn, this.availableRegions, this.algorithmParametersInfo, ...this.algorithmParameters, this.submitWarning
    // this.sidedataParameters
    ]);
  }
}, _defineProperty(_YDYRCatalogFunction, "type", "ydyr"), _YDYRCatalogFunction), _applyDecoratedDescriptor(_class.prototype, "description", [override], Object.getOwnPropertyDescriptor(_class.prototype, "description"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedTableCatalogMember", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedTableCatalogMember"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "apiUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "apiUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "inputLayers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "inputLayers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "inputLayersInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "inputLayersInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "regionColumn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "regionColumn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "regionColumnInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "regionColumnInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dataColumn", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dataColumn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dataColumnInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dataColumnInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "availableRegions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "availableRegions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "algorithmParametersInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "algorithmParametersInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "algorithmParameters", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "algorithmParameters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submitWarning", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "submitWarning"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "functionParameters", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "functionParameters"), _class.prototype), _class);
export { YDYRCatalogFunction as default };